import { USER_CURRENT_LANG } from '../comm/constant';
import { i18n } from '../language';

const getCurrentLanguage = () => {
  let lang = 'en-us';
  const cacheLang = localStorage.getItem(USER_CURRENT_LANG);
  if (cacheLang && ['en-us', 'zh-hk'].includes(cacheLang)) {
    lang = cacheLang;
  } else if (typeof navigator !== 'undefined') {
    if (Array.isArray(navigator.languages)) {
      lang = navigator.languages[0];
    }
    if (navigator.userLanguage) {
      lang = navigator.userLanguage;
    }
    if (navigator.language) {
      lang = navigator.language;
    }
  }

  if (typeof lang === 'string' && lang.length > 0) {
    if (lang.startsWith('zh')) {
      lang = 'zh-hk';
    } else {
      lang = 'en-us';
    }
  }
  localStorage.setItem(USER_CURRENT_LANG, lang);
  i18n.locale = lang;
  return lang;
};

export { getCurrentLanguage };
